import React from "react";
import "./reasons.scss";
import {useState} from 'react';
import Template from "./Template/Template.jsx";
import CountUp from 'react-countup';
import styles from "./Template/template.scss";

export default function Reasons(){
  const [counterOn, setCounterOn] = useState(false);

  const heading1="Students Have Freedom";
  const des1="Students have the freedom to curate their own plans and master the relevant topics concepts with ease.";

  const heading2="Top Notch Faculty";
  const des2="Get guidance from CELTA certified faculty members with international recognition and proven success records";

  const heading3="Interactive Live Classes";
  const des3="Get access to live classes in small batches with unlimited doubt clearing sessions";

  const heading4="Unlimited Practice";
  const des4="As Leverage Live Student, you get access to multiple mock tests, study material and constant feedback on your progress";
  return(

    <div className="reasons" id="reasons">
    <div className="MainHeader">Why Choose Leverage Live?</div>
     <div className="upper">
     <Template image="firstIcon" heading={heading1} description={des1} />
     <Template image="secondIcon" heading={heading2} description={des2} />
     <Template image="thirdIcon" heading={heading3} description={des3} />
     <Template image="fourthIcon" heading={heading4} description={des4} />
     </div>
     <div className="lower">
     <div className="lower-box">
     <div className="sect"><div className="u-1" ><CountUp start={0} end={10000} duration={2} delay={0}/>+</div><div className="l-1">Students Benifiited</div></div>
     <div className="sect"><div className="u-1" ><CountUp start={0} end={97} duration={2} delay={0}/>%</div><div className="l-1">Students scored 7+IELTS bands</div></div>
     <div className="sect"><div className="u-1"><CountUp start={0} end={200} duration={2} delay={0}/>K+</div><div className="l-1">Hours of Live Training Delivered</div></div>
     <div className="sect"><div className="u-1">4.7/5</div><div className="l-1">Average Student Rating</div></div>
     </div>
     </div>
    </div>

  )
}
